import {css} from 'styled-components';

export function maybeAddWorkspaceDropLineStyle({
  indentLevel,
  chevronWidth,
  indentPaddingFactor,
  maximumIndentLevel = 3,
}: {
  indentLevel?: number;
  chevronWidth: number;
  indentPaddingFactor: number;
  maximumIndentLevel?: number;
}) {
  const indentMultiplier = Math.min(indentLevel || 0, maximumIndentLevel);
  const indentPadding = indentMultiplier * (indentPaddingFactor - 1);
  const additionalPadding = chevronWidth + 1;

  return css`
    &::after,
    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      display: none;
    }

    /* Dot */
    &::after {
      height: 8px;
      width: 8px;
      border-radius: 4px;
      background: transparent;
      border: 2px solid ${(p) => p.theme.palette.blue.shade40};
      left: ${indentPadding + additionalPadding - 8}px;
    }

    /* Line */
    &::before {
      right: 10px;
      left: ${indentPadding + additionalPadding}px;
      height: 2px;
      background-color: ${(p) => p.theme.palette.blue.shade40};
    }

    /* Line */
    &[data-line-position='ABOVE']::before {
      top: -1px;
      display: block;
    }
    /* Dot */
    &[data-line-position='ABOVE']::after {
      top: -4px;
      display: block;
    }

    /* Dot */
    &[data-line-position='BELOW']::after {
      bottom: -4px;
      display: block;
    }
    /* Line */
    &[data-line-position='BELOW']::before {
      bottom: -1px;
      display: block;
    }
  `;
}
